import React, { useContext, useState,useEffect } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import Select from '../Select';
import { RequestsContext } from '../../context/requests';
import { BigHead } from '@bigheads/core'

const CardInput = styled.section`

    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.1rem;
    }

    div{
        margin-left:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;

        div{
            margin-left: 0rem;
            margin-top: 0.5rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;

`
const ImagePreview = styled.div`
    width: 150px;
    height: 150px;
    margin: 0 auto;
    object-fit: contain;
    border-radius: 100px;
`
const UserImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 1.1rem;
    font-family: "Poppins";
    font-weight: 500;

    p{  
        font-size: 1.1rem;
        text-align: center;
        margin-top: 0.5rem;
    }

    @media screen and (max-width:820px){

        
    }

`

const ModalClient = ({ props }) => {

    const { requestInfo, userData } = useContext(RequestsContext)
    const [sallePrice, setSallePrice] = useState()
    const [calc,setCalc] = useState()
    const handleAddClick = () => {
        props.onHide(); // Fechar a modal após adicionar
    }

    useEffect(() => {

        if (requestInfo) {
            const calc = Number(requestInfo?.quantity) * Number(requestInfo?.price)
            setSallePrice(calc)
        }

    }, [requestInfo])

    return (

        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalhes do pedido
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    <ImagePreview>
                        <BigHead
                            accessory="shades"
                            body="chest"
                            circleColor="blue"
                            clothing="tankTop"
                            clothingColor="black"
                            eyebrows="angry"
                            eyes="wink"
                            facialHair="mediumBeard"
                            graphic="vue"
                            hair="short" asd
                            hairColor="black"
                            hat="none"
                            hatColor="green"
                            lashes="false"
                            lipColor="purple"
                            mask="true"
                            faceMask="true"
                            mouth="open"
                            skinTone="brown"
                        />
                    </ImagePreview>
                    <UserImage>

                        <p>{requestInfo?.userName}</p>
                    </UserImage>
                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados do pedido</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Produto "} value={requestInfo?.name_product} />
                        <Input name={"Quantidade "} value={requestInfo?.quantity} />
                    </CardInput>
                    <CardInput>
                        <Input name={"SKU "} value={requestInfo?.sku} />
                        <Input name={"Valor Venda * "} value={Number(sallePrice).toLocaleString("pt-BR", { minimumFractionDigits: 2 })} />
                    </CardInput>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados de entrega</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>
                    <CardInput>
                        <Input name={"Rua "} value={requestInfo?.street} />
                        <Input name={"Número "} value={requestInfo?.number} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Cep "} value={requestInfo?.zipCode} />
                        <Input name={"Complemento "} value={requestInfo?.complement} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Estado "} value={requestInfo?.state} />
                        <Input name={"Cidade "} value={requestInfo?.city} />
                    </CardInput>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados do cliente</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"CPF "} value={userData?.cpf} />
                        <Input name={"Celular "} value={userData?.phone} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Email "} value={userData?.mail} />
                    </CardInput>

                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleAddClick()}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalClient